import { Bell } from 'lucide-react';
import { useState } from 'react';
import { NOTIFICATIONS } from 'shared/content/notificationsContent';

export function NotificationsBell() {
  const [isOpen, setIsOpen] = useState(false);
  const unreadCount = NOTIFICATIONS.filter((notification) => notification.unread).length;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="relative flex h-8 w-8 items-center justify-center rounded-full hover:bg-chip"
        aria-label="Notificações"
      >
        <Bell className="h-[18px] w-[18px] text-ink-secondary" aria-hidden="true" />
        {unreadCount > 0 && (
          <span className="absolute right-0.5 top-0.5 h-2 w-2 rounded-full border border-surface bg-primary" />
        )}
      </button>

      {isOpen && (
        <>
          <button
            type="button"
            aria-label="Fechar notificações"
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 z-20 mt-2 w-80 rounded-xl border border-border bg-surface p-2 text-ink shadow-card">
            <p className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-ink-secondary">
              Notificações
            </p>
            <div className="flex max-h-80 flex-col overflow-y-auto">
              {NOTIFICATIONS.map((notification) => (
                <div
                  key={notification.id}
                  className="flex gap-2 rounded-lg px-3 py-2 hover:bg-background"
                >
                  {notification.unread && (
                    <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary" />
                  )}
                  <div className={notification.unread ? '' : 'pl-3.5'}>
                    <p className="text-sm font-medium text-ink">{notification.title}</p>
                    <p className="text-sm text-ink-secondary">{notification.description}</p>
                    <p className="mt-0.5 text-xs text-ink-secondary">{notification.timeAgoLabel}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
